import { useMediaQuery, useTheme } from "@mui/material";
import { Button } from "components/mui/button";
// components
import { Card } from "components/mui/card";
import { useNavigate } from "react-router-dom";
import logoWithLine from "assets/imgs/logo-line.png";
import logo from "assets/imgs/logo.png";
// assets
import styles from "./assets/scss/boarding.module.scss";
import type { IProps } from "./types/boarding";

const Boarding = ({
  children,
  cardLabel = "Seconds to Login!",
  cardLabelStyle = styles.cardLabelStyle,
}: IProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div
      className={styles.page}
      style={{
        backgroundColor: theme.custom.background.main,
        maxHeight: "80vh",
        overflow: "auto",
      }}
    >
      <div className={styles.timer1} />
      <div className={styles.checklist1} />
      <div className={styles.timer2} />
      <div className={styles.checklist2} />
      <div className={styles.backgroundContainer}>
        <div className={`${styles.tri} ${styles.tri1}`} />
        <div className={`${styles.tri} ${styles.tri2}`} />
        <div className={`${styles.tri} ${styles.tri3}`} />
        <div className={`${styles.tri} ${styles.tri4}`} />
      </div>
      <div style={{ position: "fixed", top: "0px", width: "100vw" }}>
        <header className={styles.header}>
          <a href="../login" style={{ textDecoration: "none" }}>
            <div className={styles["logo-container"]}>
              <img src={isSmallScreen ? logo : logoWithLine} alt="Logo" />
              <p style={{ color: theme.palette.secondary.main }}>TickTrackIT</p>
            </div>
          </a>
        </header>
        <div className={styles.content}>
          <Card
            className={styles.card}
            label={<span className={cardLabelStyle}>{cardLabel}</span>}
          >
            {children}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Boarding;
